// Bound the workbench's fan-out. Every task settles independently; a disposed
// view stops scheduling work and cannot publish late responses into a new load.
export async function loadRoundQueue(items, load, settle, isCurrent, concurrency = 4) {
  let next = 0
  const workers = Math.min(items.length, Math.max(1, concurrency))
  await Promise.all(Array.from({ length: workers }, async () => {
    while (isCurrent() && next < items.length) {
      const item = items[next++]
      let error = null
      try { await load(item) } catch (failure) { error = failure }
      if (isCurrent()) settle(item, error)
    }
  }))
}

export function roundLoadMessage(error) {
  if (error && (error.code === 'ECONNABORTED' || /timeout|超时/i.test(error.message || ''))) return '请求超时，请重试'
  if (error && error.incompleteRoundData) return '数据未完整返回，已禁止保存，请重试或联系管理员'
  return '加载失败，请重试；若持续失败，请联系管理员'
}

export function completeRoundList(response) {
  const data = response && response.data
  if (!data || !Array.isArray(data.list) || Number(data.total) > data.list.length) {
    const error = new Error('赛程或对阵数据未完整返回')
    error.incompleteRoundData = true
    throw error
  }
  return data.list
}
